import PropTypes from "prop-types";
import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { translator } from "../utils/i18n";
import { Trans } from "@lingui/macro";
import { Button, Input } from "@material-ui/core";
import { PHONE_ALLOWED_COUNTRIES } from "../utils/constants";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import metadataMobile from "libphonenumber-js/metadata.mobile.json";
import { KeyboardDatePicker } from "@material-ui/pickers";

const validate = values => {
  const errors = {};
  const requiredFields = [
    "nom",
    "prenom",
    "email",
    "confirm_email",
    "cgu",
    "civilite",
    "datenaissance"
  ];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = translator()._("W_CE_CHAMP_EST_OBLIGATOIRE");
    }
  });
  /* eslint-disable no-useless-escape */
  if (values.nom && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(values.nom)) {
    errors.nom = translator()._("W_NOM_NON_VALIDE");
  }
  if (
    values.prenom &&
    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(values.prenom)
  ) {
    errors.prenom = translator()._("W_PRENOM_NON_VALIDE");
  }

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = translator()._("W_ADRESSE_E_MAIL_NON_VALIDE");
  }
  if (values.email !== values.confirm_email) {
    errors.confirm_email = translator()._(
      "W_STEP4_FORMULAIRE_ADRESSE_MAIL_IDENTIQUE"
    );
  }
  if (values.nom) {
    values.nom = values.nom.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  if (values.prenom) {
    values.prenom = values.prenom
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }
  const phoneNumber = parsePhoneNumberFromString(values.rawTel || "");
  const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
  if (values.rawTel && !telIsValid) {
    errors.mobile = translator()._("W_INVALID_PHONE");
  }
  if (telIsValid) {
    values.indicatif = phoneNumber.countryCallingCode;
    values.tel = phoneNumber.format("NATIONAL").replace(/ /g, "");
  }
  return errors;
};

class Inscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      isValidPhone: false,
      selectedDate: null
    };

    this.today = new Date();
    this.minDate = new Date();
    this.minDate.setFullYear(this.today.getFullYear() - 150);
  }

  renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      autoComplete="nope"
    />
  );

  renderTextFieldEmail = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <TextField
      type="email"
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
      autoComplete="nope"
    />
  );

  renderPhone = ({ input, meta: { error } }) => {
    return (
      <div>
        <PhoneInput
          className="intl-tel-input"
          countries={PHONE_ALLOWED_COUNTRIES}
          country={this.props.telDefault.toUpperCase()}
          defaultCountry={this.props.telDefault.toUpperCase()}
          onChange={rawTel => this.props.change("rawTel", rawTel)}
          limitMaxLength={true}
          metadata={metadataMobile}
          value={input.value}
          placeholder={`${translator()._("FORMULAIRE_TELEPHONE")}`}
          autoComplete="nope"
        />
        {error && <span className="error">{error}</span>}
      </div>
    );
  };

  renderCheckbox = ({ input }) => (
    <div className="wrap-checkbox">
      <FormControlLabel
        control={
          <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
            className="checkbox"
            color="primary"
          />
        }
      />
      <span className="label-checkbox">
        <Trans
          id="W_STEP4_FORMULAIRE_CONDITION_GENERALES_REACT"
          components={[
            <button
              key="firstLink"
              className="link-cgu no-style-btn"
              onClick={this.props.showCguDialog}
            />
          ]}
        />
      </span>
    </div>
  );

  radioButton = ({ input, ...rest }) => (
    <FormControl>
      <RadioGroup {...input} {...rest}>
        <FormControlLabel
          value="1"
          control={<Radio color="primary" />}
          label={translator()._("W_STEP4_CIVILITE_M")}
          className="radio-custom"
        />
        <FormControlLabel
          value="2"
          control={<Radio color="primary" />}
          label={translator()._("W_STEP4_CIVILITE_MME")}
          className="radio-custom"
        />
      </RadioGroup>
    </FormControl>
  );

  hiddenInput = () => {
    return <Input name="hidden-input" type="hidden" />;
  };

  handleChangeDob = date => {
    this.setState({ selectedDate: date });
    const formatedDate = date
      ? date.day + "/" + date.month + "/" + date.year
      : "";
    this.props.change("datenaissance", formatedDate);
  };

  handlePaste = e => {
    e.preventDefault();
    return false;
  };

  render() {
    const { handleSubmit, pristine, submitting, message, invalid } = this.props;
    const initialFocusedDate = new Date();
    initialFocusedDate.setFullYear(initialFocusedDate.getFullYear() - 18);
    return (
      <form
        onSubmit={handleSubmit}
        className="custom-form form-subscribe"
        autoComplete="off"
      >
        {message && (
          <div
            className="text-red"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}

        <div className="line-form radio-inline">
          <Field
            name="civilite"
            component={this.radioButton}
            autoComplete="nope"
          >
            <Radio
              value="monsieur"
              label={translator()._("W_STEP4_CIVILITE_M")}
              color="primary"
            />
            <Radio
              value="madame"
              label={translator()._("W_STEP4_CIVILITE_MME")}
              color="primary"
            />
          </Field>
        </div>
        <div className="line-form mt-15">
          <Field
            name="nom"
            component={this.renderTextField}
            label={translator()._("W_STEP4_FORMULAIRE_NOM")}
            variant="outlined"
            className="wrap-input-custom"
            autoComplete="nope"
          />
          <Field
            name="prenom"
            component={this.renderTextField}
            label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
            variant="outlined"
            className="wrap-input-custom"
            autoComplete="nope"
          />
        </div>
        <div className="line-form mt-20">
          <Field
            name="email"
            component={this.renderTextFieldEmail}
            label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
            variant="outlined"
            className="wrap-input-custom"
            autoComplete="nope"
          />
          <Field
            name="confirm_email"
            component={this.renderTextFieldEmail}
            label={translator()._("W_STEP4_FORMULAIRE_EMAIL_CONFIRMATION")}
            variant="outlined"
            className="wrap-input-custom"
            onPaste={this.handlePaste}
            autoComplete="nope"
          />
        </div>
        <div className="line-form mt-20 line-date-tel">
          <Field
            name="mobile"
            component={this.renderPhone}
            autoComplete="nope"
          />
          <KeyboardDatePicker
            className="field-custom-date"
            value={this.state.selectedDate}
            placeholder="jj/mm/aaaa"
            onChange={date => this.handleChangeDob(date)}
            minDate={this.minDate}
            maxDate={this.today}
            format="dd/MM/yyyy"
            label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
            inputVariant="outlined"
            name="dob"
            disableFuture
            openTo="year"
            views={["year", "month", "date"]}
            okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
            cancelLabel={<Trans id="W_ANNULER" />}
            initialFocusedDate={initialFocusedDate}
            invalidDateMessage={translator()._("W_DATE_INVALID")}
            maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
            minDateMessage={translator()._("W_MIN_DATE_ALERT")}
            autoComplete="nope"
          />
          <Field
            name="datenaissance"
            type="hidden"
            component={this.hiddenInput}
            autoComplete="nope"
          />
        </div>
        <div className="align-left">
          <Field
            name="cgu"
            component={this.renderCheckbox}
            label={translator()._(
              "W_STEP4_FORMULAIRE_CONDITION_GENERALES_REACT"
            )}
            autoComplete="nope"
          />
        </div>
        <div className="bottom">
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={invalid || submitting || pristine}
          >
            <Trans id="W_STEP_BOUTON_CONTINUER" />
          </Button>
        </div>
      </form>
    );
  }
}

Inscription.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.any,
  invalid: PropTypes.any,
  message: PropTypes.any,
  pristine: PropTypes.any,
  showCguDialog: PropTypes.any,
  submitting: PropTypes.any,
  telDefault: PropTypes.string
};

export default reduxForm({
  form: "InscriptionForm",
  validate
})(Inscription);
